export const ONE_YEAR_IN_MONTHS_AS_NUMBER = 12;

export const ONE_YEAR_IN_MONTHS_AS_STRING =
  ONE_YEAR_IN_MONTHS_AS_NUMBER.toString();
